import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  walletdetails: {
    margin:"10px 0px"
  },
  dataGridTable: {
    "& .MuiDataGrid-columnHeaders": {
      background: "#1D426D33",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 400,
      textTransform: "uppercase",
      fontSize: 12,
    },
    "& .MuiDataGrid-iconSeparator ": {
      color : "#000 !important",
    },
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        height: 8,
      },
    },
  },
  formwrapper:{
    margin:"20px 0px",
    justifyContent:"center",
    alignItems:"center",
  },
  totalamountblock:{
   margin:"20px 0px"
  }
}));


export default useStyles;
